import React from 'react'
import { Link, useParams, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import { toastMessage } from "../../utils/toastMessage";
import { Typography } from "@mui/material";
import { fetchExploreInsightsApi } from '../../services/exploreManagement';
import ResponsiveAnalytics from "../../components/ResponsiveAnalytics";

const ExploreInSights = () => {
  const { id: userId } = useParams();
  const [dashboardData, setDashboardData] = useState({});
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  // Fetch numerical analytics data
  const fetchDashboardAnalytics = async () => {
    try {
      showLoader();
      const sendData = { };
      console.log("sendData", sendData);
      const { data } = await fetchExploreInsightsApi(sendData);
      if (data?.code === 200) {
        setDashboardData(data?.result || {});
      } else {
        setDashboardData({});
        toastMessage(data?.message, "error", "DashboardAnalytics");
      }
    } catch (error) {
      console.error("Error fetching numerical analytics:", error);
      toastMessage("Failed to fetch analytics data", "error", "DashboardAnalytics");
    } finally {
      hideLoader();
    }
  };

  useEffect(() => {
      fetchDashboardAnalytics();
  }, []);

  // Format number for display
  const formatNumber = (value) => (value ? Number(value).toFixed(2) : "0.00");

  // Analytics data configuration
  const analyticsCards = [
    {
      title: "Total Posts",
      value: dashboardData.totalPosts || 0,
      type: "number"
    },
    {
      title: "Total Likes",
      value: dashboardData.totalLikes || 0,
      type: "number"
    },
    {
      title: "Total Comments",
      value: dashboardData.totalComments || 0,
      type: "number"
    },
    {
      title: "Engagement Rate",
      value: Math.round(dashboardData.engagementRate || 0),
      type: "percentage"
    }
  ];

  return (
    <>
      {loader}
      <ResponsiveAnalytics
        title="Explore Insights"
        data={analyticsCards}
        className="explore-insights"
      />
    </>
  );
};

export default ExploreInSights;

